import { render, staticRenderFns } from "./SerialLetterProcessView.vue?vue&type=template&id=7e2be49e&scoped=true"
import script from "./SerialLetterProcessView.vue?vue&type=script&lang=js"
export * from "./SerialLetterProcessView.vue?vue&type=script&lang=js"
import style0 from "./SerialLetterProcessView.vue?vue&type=style&index=0&id=7e2be49e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2be49e",
  null
  
)

export default component.exports